import { useState } from "react";
import { type ApiConfig, saveConfig } from "../lib/api";

interface Props {
  initial: ApiConfig;
  onClose: () => void;
  onSaved: (cfg: ApiConfig) => void;
}

export default function Settings({ initial, onClose, onSaved }: Props) {
  const [base, setBase] = useState(initial.base);
  const [token, setToken] = useState(initial.token);

  function submit(e: React.FormEvent) {
    e.preventDefault();
    const cfg: ApiConfig = { base: base.trim(), token: token.trim() };
    saveConfig(cfg);
    onSaved(cfg);
  }

  return (
    <div className="fixed inset-0 z-50 bg-ink-950/80 backdrop-blur flex items-center justify-center p-4">
      <form onSubmit={submit} className="card w-full max-w-md space-y-4">
        <header className="flex items-center justify-between">
          <h2 className="text-lg font-semibold">Ayarlar</h2>
          <button type="button" className="text-ink-400 hover:text-ink-100" onClick={onClose} aria-label="Kapat">
            ✕
          </button>
        </header>

        <label className="block space-y-1">
          <span className="label">API base</span>
          <input
            className="input w-full"
            placeholder="https://api.dijitalisler.co"
            value={base}
            onChange={(e) => setBase(e.target.value)}
            spellCheck={false}
            autoComplete="off"
          />
          <span className="text-xs text-ink-400">
            Yerel test: <code className="font-mono">http://127.0.0.1:8787</code>
          </span>
        </label>

        <label className="block space-y-1">
          <span className="label">Read token (Bearer)</span>
          <input
            type="password"
            className="input w-full"
            placeholder="Bearer token'ı yapıştır (64 hex karakter)"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            spellCheck={false}
            autoComplete="off"
          />
          <span className="text-xs text-ink-400">
            aifon-api'de <code className="font-mono">API_READ_TOKEN</code> secret'ı ile birebir aynı değer (placeholder gerçek değil — boş ise input boş kalır).
          </span>
        </label>

        <footer className="flex items-center justify-end gap-2 pt-2">
          <button type="button" className="btn-ghost" onClick={onClose}>
            İptal
          </button>
          <button type="submit" className="btn">
            Kaydet
          </button>
        </footer>
      </form>
    </div>
  );
}
